var map = {
	"./analytics-access-en.png": 71857,
	"./analytics-access-es.png": 10004,
	"./analytics-menu1-en.png": 82417,
	"./analytics-menu1-es.png": 58132,
	"./analytics-menu2-en.png": 58392,
	"./analytics-menu2-es.png": 38509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62961;